import Api from './ApiService'

export default {
    loginADM(credentials) {
        return Api().post('admins/login', credentials);
    },
    logoutADM(refreshToken) {
        return Api().post('admins/logout', { refreshToken });
    },
}
